import { FiHome, FiBook, FiSettings, FiX, FiLogOut, FiMessageSquare, FiGlobe } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

export default function  Sidebar({ open, handleLogout, setOpen }) {
  const location = useLocation();

  const links = [
    { name: "Home", path: "/dashboard", icon: <FiHome /> },
    { name: "Hook", path: "/dashboard/hook", icon: <FiBook /> },
    { name: "Pricing", path: "/dashboard/pricing", icon: <FiGlobe /> },
    { name: "Feedback", path: "/dashboard/feedback", icon: <FiMessageSquare /> },
    { name: "Settings", path: "/dashboard/settings", icon: <FiSettings /> }
  ];

  return (
    <>
      {/* Overlay sombre sur mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-40 h-full w-64 bg-[#161B22] border-r border-[#21262D] flex flex-col transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"} xl:translate-x-0`}
      >
        {/* En-tête */}
        <div className="flex items-center justify-between p-6 border-b border-[#21262D]">
          <span className="text-2xl font-bold bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
            BoostMyHook
          </span>
          <button
            onClick={() => setOpen(false)}
            className="md:hidden p-2 text-[#8B949E] hover:text-[#3B82F6] transition"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Liens */}
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setOpen(false)}
              className={`flex items-center gap-3 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                location.pathname === link.path
                  ? "bg-[#3B82F6]/20 text-[#3B82F6] shadow-[0_0_10px_#3B82F6]/40"
                  : "text-[#8B949E] hover:bg-[#21262D] hover:text-[#06B6D4]"
              }`}
            >
              {link.icon}
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-[#21262D]">
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-[#8B949E] hover:text-[#F87171] transition"
          >
            <FiLogOut /> Logout
          </button>
        </div>
      </aside>
    </>
  );
}
